import { TermAndConditionList } from '../../assets/api/useMarketingExecutive';
import { Typography } from '@mui/material';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';

const MarketingTable = ({ id }) => {
    const { data: termConditionList, isLoading: isTermConditionLaoding } = TermAndConditionList({ apartment_id: id })

    const marketingRows = termConditionList?.marketing_ads?.map((item, index) => ({
        id: item?.id || index + 1,
        sr_no: index + 1,
        ...item
    })) || []

    const marketingColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "type_of_ads",
            headerName: "Type of Ads",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "from_date",
            headerName: "Start Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
         {
            field: "to_date",
            headerName: "To Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "number_of_ads",
            headerName: "Number Of Ads",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" >
                {params.value}
            </Typography>,
        },
        {
            field: "ads_amount",
            headerName: "Ads Amount",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" >
                {params.value}
            </Typography>,
        },
       
    ];
    return (
        <>
            <TableFilterTemplate
                title="Marketing Ads"
                columns={marketingColumn}
                rowsData={marketingRows || []}
                isLoading={isTermConditionLaoding}
            />



        </>
    )
}

export default MarketingTable